import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";
import { postImport } from "common/lib/importClient";

const api = new APIClient();

// Government Requests
export const getGovtRequests = (params: any) =>
  api.get(url.GET_GOVT_REQUESTS, params);
export const getGovtRequest = (id: any, params: any) =>
  api.get(url.GET_GOVT_REQUEST + "/" + id, params);
export const addGovtRequest = (data: any) =>
  api.createAndUpload(url.ADD_GOVT_REQUEST, data);
export const updateGovtRequest = (id: any, data: any) =>
  api.put(url.UPDATE_GOVT_REQUEST + "/" + id, data);
export const deleteGovtRequest = (id: any) =>
  api.delete(url.DELETE_GOVT_REQUEST + "/" + id);
export const importGovtRequests = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_GOVT_REQUEST, data, accessToken, options);
export const exportGovtRequestsToCsv = (params: any) =>
  api.get(url.EXPORT_GOVT_REQUESTS_TO_CSV, params, {
    responseType: "blob",
  });

// Request Types
export const getRequestTypes = (params: any) =>
  api.get(url.GET_REQUEST_TYPES, params);
export const getRequestType = (id: any, params: any) =>
  api.get(url.GET_REQUEST_TYPE + "/" + id, params);
export const addRequestType = (data: any) =>
  api.create(url.ADD_REQUEST_TYPE, data);
export const updateRequestType = (id: any, data: any) =>
  api.put(url.UPDATE_REQUEST_TYPE + "/" + id, data);
export const deleteRequestType = (id: any) =>
  api.delete(url.DELETE_REQUEST_TYPE + "/" + id);

// Form of Government Requests
export const getFormOfRequests = (params: any) =>
  api.get(url.GET_FORM_OF_REQUESTS, params);
export const getFormOfRequest = (id: any, params: any) =>
  api.get(url.GET_FORM_OF_REQUEST + "/" + id, params);
export const addFormOfRequest = (data: any) =>
  api.create(url.ADD_FORM_OF_REQUEST, data);
export const updateFormOfRequest = (id: any, data: any) =>
  api.put(url.UPDATE_FORM_OF_REQUEST + "/" + id, data);
export const deleteFormOfRequest = (id: any) =>
  api.delete(url.DELETE_FORM_OF_REQUEST + "/" + id);

// Agency Government Requests
export const getAgencyGovtRequests = (params: any) =>
  api.get(url.GET_AGENCY_GOVT_REQUESTS, params);
export const getAgencyGovtRequest = (id: any, params: any) =>
  api.get(url.GET_AGENCY_GOVT_REQUEST + "/" + id, params);
export const addAgencyGovtRequest = (data: any) =>
  api.createAndUpload(url.ADD_AGENCY_GOVT_REQUEST, data);
export const updateAgencyGovtRequest = (id: any, data: any) =>
  api.put(url.UPDATE_AGENCY_GOVT_REQUEST + "/" + id, data);
export const deleteAgencyGovtRequest = (id: any) =>
  api.delete(url.DELETE_AGENCY_GOVT_REQUEST + "/" + id);

// Public Government Requests
export const addPublicGovernmentRequest = (data: any) =>
  api.createAndUpload(url.ADD_PUBLIC_GOVERNMENT_REQUEST, data);

// LOAs
export const getLOAs = (params: any) => api.get(url.GET_LOAS, params);
export const getLOA = (id: any, params: any) =>
  api.get(url.GET_LOA + "/" + id, params);
export const addLOA = (data: any) => api.createAndUpload(url.ADD_LOA, data);
export const updateLOA = (id: any, data: any) =>
  api.updateAndUpload(url.UPDATE_LOA + "/" + id, data);
export const deleteLOA = (id: any) => api.delete(url.DELETE_LOA + "/" + id);
export const getLOASummary = (params: any) =>
  api.get(url.GET_LOA_SUMMARY, params);
export const exportLOAToCSV = (params: any) =>
  api.get(url.EXPORT_LOA_TO_CSV, params);
export const importLOA = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_LOA, data, accessToken, options);
